import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './Header.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default function Header({ n, name, toggle }) {
  const { Header, Active } = Styles;
  return (
    <div className={C(Header, [name, Active])} onClick={toggle}>
      <FontAwesomeIcon icon={faSearch} />
      <span>{n}ª Etapa Fenológica{name && ': '} {name}</span>
    </div>
  );
}

Header.defaultProps = {
  name: '',
};

Header.propTypes = {
  n: PropTypes.number.isRequired,
  name: PropTypes.string,
  toggle: PropTypes.func.isRequired,
};
